import StructureLabel from 'components/Luxkit/Label/StructureLabel'
import switchFunc from 'lib/function/switchFunc'
import React, { useMemo } from 'react'

const cabinToLabelVariant = switchFunc<React.ComponentProps<typeof StructureLabel>['variant'], string>({
  Business: 'dark',
  First: 'exclusive',
}, 'premium')

interface Props {
  fareFamily: App.FlightFareFamily;
}

function FareFamilyClassLabel(props: Props) {
  const { fareFamily } = props

  const label = useMemo(() => {
    const description = fareFamily.fareFamily.description
    if (fareFamily.withEmbeddedInsurance) {
      return 'Luxury Escapes Protect'
    }
    return description
  }, [fareFamily.fareFamily.description, fareFamily.withEmbeddedInsurance])

  return (<StructureLabel
    variant={cabinToLabelVariant(fareFamily.cabin)}
  >
    {label}
  </StructureLabel>)
}

export default FareFamilyClassLabel
